import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CONVENIOS_URL}${process.env.VUE_APP_API_PATH}/convenios`

export default {
    obterModelos() {
        return axiosJwt
            .get(`${api}/modelos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirModelo(modelo) {
        const formData = new FormData()
        formData.append('codigo', modelo.codigo)
        formData.append('descricao', modelo.descricao)
        formData.append('objeto', modelo.objeto)
        formData.append('arquivo', modelo.arquivo)

        return axiosJwt
            .post(`${api}/modelos`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarModelo(modelo) {
        const formData = new FormData()
        formData.append('modeloId', modelo.modeloId)
        formData.append('codigo', modelo.codigo)
        formData.append('descricao', modelo.descricao)
        formData.append('objeto', modelo.objeto)
        formData.append('arquivo', modelo.arquivo)

        return axiosJwt
            .put(`${api}/modelos`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    download(modelo) {
        return axiosJwt
            .get(`${api}/modelos/${modelo.modeloId}/download`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
